import {
    INVALID_DOCUMENT_ERROR_TEXT_BY_DOCUMENT_TYPE_AGGREGATION,
    INVALID_DOCUMENT_ERROR_TITLE_BY_DOCUMENT_TYPE_AGGREGATION,
    VIDEO_CALL_MODAL_CONTENT_BY_STATUS_CODE,
    VIDEO_CALL_MODAL_TITLE_BY_STATUS_CODE,
    VIDEOSELFIE_DIRECT_ERROR_TEXT_BY_STATUS_CODE,
    VIDEOSELFIE_DIRECT_ERROR_TITLE_BY_STATUS_CODE,
} from 'constants/video/statusTexts';
import { getDocumentTypeAggregation } from 'utilities/documentTypes';
import { ERROR, INVALID_DOCUMENT } from 'constants/video/status';

const getInvalidDocumentMessage = documentType => {
    const documentTypeAggregation = getDocumentTypeAggregation(documentType);

    const title = INVALID_DOCUMENT_ERROR_TITLE_BY_DOCUMENT_TYPE_AGGREGATION[documentTypeAggregation] ?? '';
    const content =
        INVALID_DOCUMENT_ERROR_TEXT_BY_DOCUMENT_TYPE_AGGREGATION[documentTypeAggregation] ??
        VIDEOSELFIE_DIRECT_ERROR_TEXT_BY_STATUS_CODE[INVALID_DOCUMENT];

    return {
        title,
        content,
    };
};

const getTextMessageByVideoSelfieStatusCode = ({ documentType, statusCode }) => {
    if (statusCode === INVALID_DOCUMENT) return getInvalidDocumentMessage(documentType);

    const title =
        VIDEOSELFIE_DIRECT_ERROR_TITLE_BY_STATUS_CODE[statusCode] ??
        VIDEOSELFIE_DIRECT_ERROR_TITLE_BY_STATUS_CODE[ERROR];
    const content =
        VIDEOSELFIE_DIRECT_ERROR_TEXT_BY_STATUS_CODE[statusCode] ?? VIDEOSELFIE_DIRECT_ERROR_TEXT_BY_STATUS_CODE[ERROR];

    return {
        title,
        content,
    };
};

const getTextMessageByVideoCallStatusCode = ({ statusCode }) => {
    const title = VIDEO_CALL_MODAL_TITLE_BY_STATUS_CODE[statusCode] ?? '';
    const content =
        VIDEO_CALL_MODAL_CONTENT_BY_STATUS_CODE[statusCode] ?? VIDEO_CALL_MODAL_CONTENT_BY_STATUS_CODE[ERROR];

    return {
        title,
        content,
    };
};

export const getTextMessageByVideoStatusCode = ({ isVideoSelfie, documentType, statusCode }) => {
    if (isVideoSelfie) return getTextMessageByVideoSelfieStatusCode({ documentType, statusCode });

    return getTextMessageByVideoCallStatusCode({ statusCode });
};
